const ITEMS = [
  "Salons For Sale",
  "Low 4% Commission",
  "Specialists in Hair & Beauty",
  "Confidential Appraisals",
  "Indicative Valuation in 2 Minutes",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="trust-marquee"
      className={`overflow-hidden border-y ${
        dark ? "bg-primary border-white/10" : "bg-background border-border"
      } py-5`}
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-serif text-2xl md:text-3xl px-8 ${
                dark ? "text-primary-foreground" : "text-foreground"
              }`}
            >
              {item}
            </span>
            <span className="text-brand text-2xl">&#10023;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
